import { MessageCircle, MousePointerClick, Phone } from "lucide-react";
import "./badge.css"

const SOURCE_META = {
  Chat: { icon: MessageCircle, label: "Chat", className: "source-chat" },
  Activity: { icon: MousePointerClick, label: "Activity", className: "source-activity" },
  Call: { icon: Phone, label: "Call", className: "source-call" },
};

export default function SourceBadges({ sources = [] }) {
  if (!sources.length) {
    return <span className="source-capsule source-capsule-empty">—</span>;
  }

  return (
    <div className="source-capsule">
      {sources.map((key, idx) => {
        const meta = SOURCE_META[key];
        if (!meta) return null;
        const Icon = meta.icon;
        return (
          <span
            key={key}
            className={`source-row ${meta.className} ${idx > 0 ? "source-row-divided" : ""}`}
          >
            <Icon size={11} strokeWidth={2.25} />
            <span className="source-label">{meta.label}</span>
          </span>
        );
      })}
    </div>
  );
}
